<div class="flex flex-col h-full">
  <p-toolbar>
    <ng-template pTemplate="start">
      <div class="flex gap-4">
        <p-iconfield>
          <p-inputicon styleClass="pi pi-search" />
          <input
            type="text"
            pInputText
            [(ngModel)]="searchText"
            (keyup.enter)="onSearch()" />
        </p-iconfield>
        <div class="flex items-center">
          <p-checkbox
            [(ngModel)]="medtagSlettede"
            [binary]="true"
            (onChange)="onSearch()" />
          <label class="ml-2"> Medtag slettede </label>
        </div>
      </div>
    </ng-template>
  </p-toolbar>

  @let apiResponse = data.value();
  @if (apiResponse) {
    <p-table
      [value]="apiResponse.data"
      [loading]="data.isLoading()"
      [showGridlines]="true"
      stripedRows
      selectionMode="single"
      [metaKeySelection]="true"
      [(selection)]="dokumenterService.selectedDokument"
      (onRowSelect)="onRowSelect($event)"
      dataKey="id"
      [scrollable]="true"
      scrollHeight="flex"
      class="flex-1 overflow-hidden p-datatable-sm mt-4">
      >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="oprettelsesTidspunkt">
            Uploaded
            <p-sortIcon field="fornavn" />
          </th>
          <th pSortableColumn="emne">
            Navn
            <p-sortIcon field="emne" />
          </th>
        </tr>
      </ng-template>
      <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-item>
        <tr [pSelectableRow]="item" class="cursor-pointer">
          <td class="numbers">
            {{ item.oprettelsesTidspunkt | date: 'dd-MM-yyyy HH:mm' }}
          </td>
          <td>{{ item.emne }}</td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
